import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            enableBackground={"new 0 0 512 512;"}
            xmlSpace="preserve"
        >
            <path
                fill="none"
                stroke="#fff"
                strokeWidth={"10"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit={"10"}
                d="M459.9,445H52.1C26.7,445,6,424.3,6,398.9V113.1C6,87.7,26.7,67,52.1,67h407.9c25.3,0,46.1,20.7,46.1,46.1
	v285.9C506,424.3,485.3,445,459.9,445z"
            />
            <g>
                <line
                    fill="none"
                    stroke="#fff"
                    strokeWidth={"10"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={"10"}
                    x1="188.9"
                    y1="259.8"
                    x2="62.3"
                    y2="384"
                />
                <line
                    fill="none"
                    stroke="#fff"
                    strokeWidth={"10"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={"10"}
                    x1="323.1"
                    y1="259.8"
                    x2="449.7"
                    y2="384"
                />
                <polyline
                    fill="none"
                    stroke="#fff"
                    strokeWidth={"10"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={"10"}
                    points="462,128 256.9,316.6 50,128 	"
                />
            </g>
        </svg>
    );
};

export default React.memo(ChevronLeft);
